module.exports = __webpack_public_path__ + "static/img/1-4.ce9b454.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/1-4.png
// module id = wYTF
// module chunks = 0